var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import Icon from '../Icon';

var CopyButton = function (_Component) {
  _inherits(CopyButton, _Component);

  function CopyButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CopyButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyButton.__proto__ || Object.getPrototypeOf(CopyButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showFeedback: false
    }, _this.handleClick = function (evt) {
      _this.setState({ showFeedback: true });
      _this.timeoutId = setTimeout(function () {
        _this.setState({ showFeedback: false });
      }, _this.props.feedbackTimeout);

      _this.props.onClick(evt);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CopyButton, [{
    key: 'componentWillUnmount',

    /* istanbul ignore next */
    value: function componentWillUnmount() {
      if (typeof this.timeoutId !== 'undefined') {
        clearTimeout(this.timeoutId);
        delete this.timeoutId;
      }
    }
  }, {
    key: 'render',
    // eslint-disable-line no-unused-vars
    value: function render() {
      var _props = this.props,
          iconDescription = _props.iconDescription,
          className = _props.className,
          feedback = _props.feedback,
          feedbackTimeout = _props.feedbackTimeout,
          onClick = _props.onClick,
          other = _objectWithoutProperties(_props, ['iconDescription', 'className', 'feedback', 'feedbackTimeout', 'onClick']);

      var classNames = classnames('bx--snippet-button', className);
      var feedbackClassNames = classnames('bx--btn--copy__feedback', {
        'bx--btn--copy__feedback--displayed': this.state.showFeedback
      });
      return React.createElement(
        'button',
        _extends({
          type: 'button',
          className: classNames,
          onClick: this.handleClick
        }, other),
        React.createElement(Icon, {
          className: 'bx--snippet__icon',
          name: 'copy',
          description: iconDescription
        }),
        React.createElement('div', { className: feedbackClassNames, 'data-feedback': feedback })
      );
    }
  }]);

  return CopyButton;
}(Component);

CopyButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  iconDescription: PropTypes.string,
  feedback: PropTypes.string,
  feedbackTimeout: PropTypes.number,
  onClick: PropTypes.func
};
CopyButton.defaultProps = {
  iconDescription: 'Copy to clipboard',
  feedback: 'Copied!',
  feedbackTimeout: 2000,
  onClick: function onClick() {}
};
export default CopyButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/CopyButton/CopyButton.js
// module id = 302
// module chunks = 0